// --- CONFIGURACIÓN Y SELECTORES ---
const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const selectors = { button: '[button-wishlist]',grid: '[grid-wishlist]' };

// --- LÓGICA PRINCIPAL (BASADA EN LOCALSTORAGE) ---

/**
 * Obtiene la wishlist de localStorage, manejando tanto el formato de array JSON
 * como el de string separado por comas para evitar errores con datos antiguos.
 */
const getWishlist = () => {
    const localData = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
    if (!localData) return [];

    // Intento 1: ¿Es un array en formato JSON (de un intento anterior)?
    try {
        const parsed = JSON.parse(localData);
        if (Array.isArray(parsed)) {
            return parsed.filter(handle => typeof handle === 'string' && handle.length > 0);
        }
    } catch (e) {
        // No era un JSON válido, lo cual es normal. Pasamos al siguiente intento.
    }

    // Intento 2: Es un string separado por comas (el formato estándar de esta versión).
    if (typeof localData === 'string' && localData.length > 0) {
        // Nos aseguramos de limpiar cualquier carácter problemático residual.
        return localData.replace(/[\[\]"]/g, '').split(',').filter(Boolean);
    }

    // Si el formato es desconocido, devolvemos un array vacío para no romper la web.
    return [];
};

const updateWishlist = (handle) => {
    let currentList = getWishlist();
    const index = currentList.indexOf(handle);
    const wasAdded = index === -1;

    if (wasAdded) { currentList.push(handle); } 
    else { currentList.splice(index, 1); }

    // Siempre guardamos en el formato correcto: string simple separado por comas.
    if (currentList.length > 0) {
        localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, currentList.join(','));
    } else {
        localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    }

    // Si el cliente está logueado, guardamos también en el servidor.
    if (window.myShopify?.customerId) {
        saveWishlistOnServer(currentList);
    }

    showWishlistAlert(wasAdded ? 'Añadido a la lista de deseos' : 'Eliminado de la lista de deseos', wasAdded ? '#EAF6F0' : '#D88868');
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
};

const saveWishlistOnServer = (wishlistArray) => {
    if (!window.myShopify?.customerId) return;

    // /apps/wishlist/SaveWishlist
    fetch('https://jrs.uno/webhook/api/Shopify/SaveWishlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            CustomerId: window.myShopify.customerId, // La 'C' y la 'W' en mayúscula para coincidir con el modelo de C#
            Wishlist: wishlistArray
        }),
    })
    .then(res => res.json())
    .then(data => {
        if (!data.success) {
            console.error('El servidor devolvió un error al guardar la wishlist:', data.message);
        }
    })
    .catch(error => console.error('[Wishlist] Error de red al llamar al App Proxy:', error));
};

// --- FUNCIONES DE RENDERIZADO DE LA INTERFAZ (UI) ---

const fetchRenderedProductCard = (handle) => {
    const url = `/products/${handle}?view=card-render`;
    return fetch(url)
        .then(res => {
            if (!res.ok) throw new Error(`El servidor respondió con estado ${res.status} para el producto ${handle}`);
            return res.text();
        })
        .catch(err => {
            console.error(`[Wishlist] No se pudo renderizar la tarjeta para: ${handle}`, err);
            return '';
        });
};

const setupGrid = async () => {
    const grid = document.querySelector(selectors.grid);
    if (!grid) return;

    const wishlist = getWishlist();
    grid.classList.remove(GRID_LOADED_CLASS);

    if (wishlist.length === 0) {
        grid.innerHTML = '<div><p class="wishlist__empty">Tu lista de deseos está vacía.</p><a style="color:#fff;margin-top:20px;" class="btn btn--solid" href="/collections/all">DESCUBRE NUESTROS PRODUCTOS</a></div>';
        return;
    }

    grid.innerHTML = '<p class="wishlist__loading">Cargando tu lista de deseos...</p>';
    
    const cardPromises = wishlist.map(fetchRenderedProductCard);
    const renderedCards = await Promise.all(cardPromises);
    
    grid.innerHTML = renderedCards.join('');
    grid.classList.add(GRID_LOADED_CLASS);
    setupButtons();
};

const setupButtons = () => {
    const wishlist = getWishlist();
    const buttons = document.querySelectorAll(selectors.button);
    buttons.forEach(button => {
        const handle = button.dataset.productHandle;
        button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlist.includes(handle));
    });
};

// --- FUNCIONES AUXILIARES ---
function createWishlistAlertContainers() { if (document.getElementById('wishlist-alert-container')) return; const container = document.createElement('div'); container.id = 'wishlist-alert-container'; container.style.cssText = 'position: fixed; top: 120px; right: 10px; z-index: 10000000; display: flex; flex-direction: column; gap: 10px; align-items: end;'; document.body.appendChild(container); }
function showWishlistAlert(message, backgroundColor) { const container = document.getElementById('wishlist-alert-container'); if (!container) return; const alertDiv = document.createElement('div'); alertDiv.textContent = message; alertDiv.style.cssText = `background-color: ${backgroundColor}; color: #000; padding: 10px 20px; border-radius: 5px; box-shadow: 0 0 10px rgba(0,0,0,0.2); transition: opacity 0.5s ease;`; container.innerHTML = ''; container.appendChild(alertDiv); setTimeout(() => { alertDiv.style.opacity = '0'; alertDiv.addEventListener('transitionend', () => alertDiv.remove()); }, 3000); }
function observeProductListUpdates() { const selectorsToWatch = ['#ShopProducts', '.product-recommendations', '#SearchSidebar']; const observer = new MutationObserver(() => setupButtons()); selectorsToWatch.forEach(selector => { const targetNode = document.querySelector(selector); if (targetNode) observer.observe(targetNode, { childList: true, subtree: true }); }); }

// --- INICIALIZACIÓN Y EVENTOS ---
document.addEventListener('DOMContentLoaded', () => {
    
    // 1. OBTENER DATOS
    // Esperamos que window.myShopify.wishlist SEA UN ARRAY DE JAVASCRIPT, no un string.
    const serverWishlist = window.myShopify?.wishlist || []; 
    const localWishlist = getWishlist();
    
    // 2. FUSIONAR Y SINCRONIZAR
    const combined = [...new Set([...serverWishlist, ...localWishlist])];

    // Guardar la lista fusionada en el formato correcto (JSON Array)
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(combined));
    
    // Si el usuario está logueado y las listas eran diferentes, sincronizar con el servidor.
    if (window.myShopify?.customerId && combined.length !== serverWishlist.length) {
        saveWishlistOnServer(combined);
    }
  
    setupButtons();
    setupGrid();
    observeProductListUpdates();
    createWishlistAlertContainers();

    document.addEventListener('wishlist:updated', () => {
        setupButtons();
        setupGrid();
    });

    document.body.addEventListener('click', (event) => {
        const button = event.target.closest(selectors.button);
        if (button) {
            event.preventDefault();
            const handle = button.dataset.productHandle;
            if (handle) updateWishlist(handle);
        }
    });
});